import React from "react";
import noEntriesIcon from "@/assets/NoEntriesIcon.svg?url";

interface Props {
	title: string;
	children: React.ReactNode;
}

const NoEntries = ({ title, children }: Props): JSX.Element => (
	<div className="ClassroomChat_noEntries" data-testid="no-entries">
		<img src={noEntriesIcon} alt="" />
		<p>
			<strong>{title}</strong>
		</p>
		{children}
	</div>
);

export default NoEntries;
